/***************************************************************************************************
** getResourceConfig
***************************************************************************************************/

import resourcesConfig from "./../../../../../lib/kinn/config/resources.yml";

export default function getResourceConfig(name) {
  if (!name) return undefined;

  const config = Object.values(resourcesConfig).find((r) => r.name === name);

  if (!config) {
    console.error(`[getResourceConfig] Unknown resource "${name}" — no matching entry in resources.yml`);
    window.rollbar?.warning(`[getResourceConfig] Unknown resource "${name}"`);

    return {
      name: undefined,
      description: undefined,
      path: undefined,
      icon: {
        name: undefined,
      },
    };
  }

  return config;
}
